'use client'

import { Button } from '@material-bank/mb3-components'
import { useTranslations } from '@material-bank/i18n'
import { useAuthProvider } from '../../providers/AuthProvider'

type LogoutButtonProps = {
  onLogout?: () => void
  className?: string
}

export function LogoutButton({ onLogout, className }: LogoutButtonProps) {
  const t = useTranslations('authentication.logoutButton')
  const { logout, status } = useAuthProvider()

  const isLoading = status === 'logging-out'

  async function logoutHandler() {
    await logout()
    onLogout?.()
  }

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={isLoading}
      onClick={logoutHandler}
      className={className}
    >
      {isLoading ? t('buttonLoading') : t('button')}
    </Button>
  )
}
